import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContentModelPopupDetails } from '../../model/content/contentModelPopupDetails.model';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';

declare let delta: any;

@Component({
  selector: 'ngc-modal-popup',
  templateUrl: 'flyout-modal.html'
})
export class FlyoutModalComponent implements OnInit, OnDestroy {
  @ViewChild('dialog') dialog;
  @Output() action = new EventEmitter();
  @Input() isECertify: boolean;
  @Input() isCorporateRewards: boolean;
  hrefUrl: any;
  target: any;
  public timeouts = [];
  contentServiceHeaderFooterSubscribe: Subscription;
  axPopupContent: ContentModelPopupDetails;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    public bsModalRef: BsModalRef,
    private cdref: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
    private contentService: ContentHeaderFooterService
  ) {}

  ngOnInit() {
    this.contentServiceHeaderFooterSubscribe =
      this.contentService.contentHeaderFooter
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((data) => {
          setTimeout(() => {
            if (this.isECertify) {
              this.axPopupContent = data.header.modelPopups.get(
                'negotiatedfaresecert'
              ).details;
            } else {
              this.axPopupContent = data.header.modelPopups.get(
                'negotiatedfaresmcode'
              ).details;
            }
          }, 10);
        });
  }

  submit() {
    this.action.emit(this.axPopupContent.submitUrl);
    this.close();
  }

  close() {
    this.bsModalRef.hide();
    document.getElementsByTagName('html')[0].classList.remove('no-scroll');
    if (!this.isCorporateRewards) {
      document.getElementById('btnSubmit').focus();
    }
  }

  ngOnDestroy() {
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
